module.exports = __webpack_public_path__ + "img/face.9269a780.svg";